import whitelabelService from "../../../../../services/whitelabel/whitelabel.service";
import VehicleData from "./vehicle-data.entity";

interface AgricituralMachineData {
  chassis: string;
  vehicle_data: {
    model: string;
    brand: string;
    version: string;
    vehicle_type: string;
    year_manufacture: string;
    year_model: string;
  }
}

class AgricituralMachine {
  public chassis: string;
  public vehicleData: VehicleData;

  constructor(data: AgricituralMachineData = {
    chassis: "",
    vehicle_data: {
      model: "",
      brand: "",
      version: "",
      vehicle_type: "",
      year_manufacture: "",
      year_model: ""
    }
  }) {
    this.chassis = data.chassis;
    this.vehicleData = new VehicleData(data.vehicle_data);
  }

  public formatPaylod() {
    const whitelabelCompany = whitelabelService
      .getWBDataCompany();

    return {
      chassis: this.chassis,
      api_token: whitelabelCompany.api,
      vehicle_data: this.vehicleData.formatPayload()
    }
  }
}

export default AgricituralMachine;
